import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { ListingFunnelInterface } from 'modules/funnels/funnel/types/funnel-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useFunnels(funnelId, shouldFetch) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== funnelId || $[2] !== shouldFetch || $[3] !== user) {
    t1 = () => {
      if (user && shouldFetch) {
        return `${FUNNELS_API}/${funnelId}/list`;
      }
      return null;
    };
    $[1] = funnelId;
    $[2] = shouldFetch;
    $[3] = user;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: funnelsList
  } = useSWR(t1, fetcher);
  let t2;
  if ($[5] !== funnelsList) {
    t2 = {
      funnelsList
    };
    $[5] = funnelsList;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}